import { useState, useMemo } from 'react';
import {
	DATA_SET_OPTIONS,
	DATA_SET_VIOLATION_OPTIONS,
	DATA_SET_APPROVALS_OPTIONS
} from 'pages/backendSearch/backendSearchConstants';

import Collapse from 'components/Collapse';

const DataSetGroup = ({ title, items, selectedDataSet, onSelect, initCollapsed, searchTerm }) => {
	// Filter items based on search term
	const filteredItems = useMemo(() => {
		if (!searchTerm) return items;
		const lowerSearch = searchTerm.toLowerCase();
		return items.filter(item =>
			item.label.toLowerCase().includes(lowerSearch) ||
			item.value.toLowerCase().includes(lowerSearch)
		);
	}, [items, searchTerm]);

	if (filteredItems.length === 0 && searchTerm) {
		return null;
	}

	return (
		<div>
			<Collapse title={title} initCollapsed={initCollapsed} >
				<div>
					{filteredItems.map((option) => (
						<label key={option.value} className={`data-set-radio-option ${selectedDataSet === option.value ? 'is-selected' : ''}`}>
							<input
								type="radio"
								name="dataSet"
								key={option.value}
								value={option.value}
								checked={selectedDataSet === option.value}
								onChange={onSelect}
							/>
							<span className="label-text">{option.label}</span>
						</label>
					))}
				</div>
			</Collapse>
		</div>
	);
}

export const DataSetSelectDesktop = ({ selectedDataSet, onSelect }) => {
	const [searchTerm, setSearchTerm] = useState('');

	return (
		<div className="data-set-select">
			<h2>Select Data Set</h2>
			<div className="data-set-search-wrapper">
				<div className="data-set-search-input-wrapper">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="data-set-search-icon">
						<path d="M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M14.5 14.5L11.5 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
					<input
						type="text"
						className="form-control data-set-search-input"
						placeholder="Search datasets..."
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
					/>
					{searchTerm && (
						<button
							className="data-set-search-clear"
							onClick={() => setSearchTerm('')}
							type="button"
						>
							<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</button>
					)}
				</div>
			</div>
			<div className="data-set-options-desktop">
				<DataSetGroup title="Approvals" items={DATA_SET_APPROVALS_OPTIONS} selectedDataSet={selectedDataSet} onSelect={onSelect} searchTerm={searchTerm} />
				<DataSetGroup title="Violations" items={DATA_SET_VIOLATION_OPTIONS} selectedDataSet={selectedDataSet} onSelect={onSelect} initCollapsed searchTerm={searchTerm} />
{/*				{DATA_SET_OPTIONS.map((option) => (
					<label key={option.value} className={`data-set-radio-option ${selectedDataSet === option.value ? 'is-selected' : ''}`}>
						<input
							type="radio"
							name="dataSet"
							key={option.value}
							value={option.value}
							checked={selectedDataSet === option.value}
							onChange={onSelect}
						/>
						<span className="label-text">{option.label}</span>
					</label>
				))}*/}
			</div>
		</div>
	);
}

export const DataSetSelectMobile = ({ selectedDataSet, onSelect }) => {
	return (
		<select
			className="form-select"
			placeholder="Select Data Set"
			value={selectedDataSet}
			onChange={onSelect}
			autoFocus
		>
			{DATA_SET_OPTIONS.map((option) => (
				<option key={option.value} value={option.value}>{option.label}</option>
			))}
		</select>
	);
}